<template>
  <div class="layout-issue layout-location">
    <slot name="headerBar" />

    <div class="issue">
      <div class="issue-location">
        <div class="issue-location__panel-left">
          <div class="issue-location__navigation">
            <router-link
              v-for="link in panelNavLinks"
              :key="link?.name"
              activeClass="issue-location__navigation-link--active"
              :aria-disabled="isExistingIssue($route.params)"
              :class="{
                'issue-location__navigation-link': true,
                'issue-location__navigation-link--active': setActivePanel(link?.id, $route?.name),
                'issue-location__navigation-link--disable': isExistingIssue($route.params)
              }"
              :to="{ name: link?.name, params: { issueId: $route.params.issueId } }"
            >
              {{ link?.label }}
            </router-link>
          </div>
          <div class="issue-location__panel-left-content show-for-medium">
            <slot name="leftContent" />
          </div>
        </div>
        <div class="issue-location__panel-main">
          <slot name="mainContent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import isExistingIssue from '@/functions/existing_issue';

defineProps({
  /** Panel option list */
  panelNavLinks: { type: Array, required: true, default: () => [] },
});

function setActivePanel(id, name) {
  return name.includes(id);
}
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.layout-location {
  display: flex;
  flex-direction: column;
  height: 100%;

  .issue {
    border-radius: 0;
    margin: bu(1.5) 0 0 0;

    @include breakpoint(medium) {
      border-radius: map-get($border-radius, mega-heavy);
      margin: bu(1.5);
    }
  }
  .issue-location {
    width: 100%;

    @include breakpoint(medium) {
      display: grid;
      grid-template-columns: rem(300) 1fr;
    }

    &__panel-left {
      background-color: map-get($background-color, default);
      padding: bu(2.5);
    }

    &__panel-left-content {
      padding: bu(1.5) 0;
    }

    &__panel-main {
      align-items: center;
      background-color: map-get($background-color, darkest);
      display: flex;
      justify-content: center;
      overflow: hidden;
    }

    &__navigation {
      border-bottom: 1px solid map-get($foreground-color, darker);
      padding-bottom: bu(1);
      display: flex;
    }

    &__navigation-link {
      color: map-get($foreground-color, dark);
      font-style: normal;
      font-weight: 400;

      &:not(:last-child) {
        margin-right: bu(2);
      }

      &--active {
        color: $white;
      }

      &--disable {
        pointer-events: none;
      }
    }
  }
}
</style>
